import DOMPurify from "dompurify";

// Convert a YouTube / Instagram / Facebook URL into an embeddable iframe src.
export function parseEmbed(rawUrl) {
  if (!rawUrl) return null;
  const url = rawUrl.trim();
  let m;
  if ((m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([\w-]{11})/i))) {
    return `https://www.youtube.com/embed/${m[1]}`;
  }
  if ((m = url.match(/instagram\.com\/(p|reel|reels|tv)\/([\w-]+)/i))) {
    const kind = m[1].toLowerCase() === "reels" ? "reel" : m[1].toLowerCase();
    return `https://www.instagram.com/${kind}/${m[2]}/embed`;
  }
  if (/facebook\.com\//i.test(url) || /fb\.watch\//i.test(url)) {
    const isVideo = /\/videos?\//i.test(url) || /watch\/?\?v=/i.test(url) || /fb\.watch/i.test(url);
    const plugin = isVideo ? "video.php" : "post.php";
    return `https://www.facebook.com/plugins/${plugin}?href=${encodeURIComponent(url)}&show_text=true&width=500`;
  }
  return null;
}

const TRUSTED_IFRAME = /^https:\/\/(www\.)?(youtube\.com|youtube-nocookie\.com|player\.vimeo\.com|instagram\.com|facebook\.com)\//i;

let hookAdded = false;
function ensureHook() {
  if (hookAdded) return;
  hookAdded = true;
  DOMPurify.addHook("uponSanitizeElement", (node, data) => {
    if (data.tagName === "iframe") {
      const src = node.getAttribute("src") || "";
      if (!TRUSTED_IFRAME.test(src)) node.parentNode?.removeChild(node);
    }
  });
}

// Sanitize rich HTML for the public pages: keeps formatting, inline images, and
// embeds from trusted domains only. Strips pasted Word/Docs inline styles.
export function sanitizeRich(html) {
  ensureHook();
  const raw = Array.isArray(html) ? html.map((p) => `<p>${p}</p>`).join("") : html || "";
  return DOMPurify.sanitize(raw, {
    ALLOWED_TAGS: ["p", "br", "h2", "h3", "h4", "strong", "b", "em", "i", "u", "s", "ul", "ol", "li", "a", "blockquote", "img", "iframe"],
    ALLOWED_ATTR: ["href", "target", "rel", "src", "alt", "class", "allow", "allowfullscreen", "frameborder", "width", "height"],
    ADD_TAGS: ["iframe"],
  });
}
